import React, { Suspense } from "react";
import {/*Redirect, Route,*/ Switch} from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
// import { BuilderPage } from "./pages/BuilderPage";
import { DashboardPage } from "./pages/DashboardPage";
import {WizardPage} from "./modules/Wizard/WizardPage";
import {CalendarPage} from "./modules/Calendar/CalendarPage";
// import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
// import Intro from "./modules/Intro/Intro";
// import {OrderSheetPage} from "./modules/OrderSheet/OrderSheetPage";
import {PaymentPage} from "./modules/Payment/PaymentPage";

// const UserProfilepage = lazy(() =>
//   import("./modules/UserProfile/UserProfilePage")
// );

// const WizardPage = lazy(() =>
//     import("./pages/WizardPage")
// )

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {/*{*/}
        {/*  /* Redirect from root URL to /dashboard. */}
        {/*  <Redirect exact from="/" to="/s/:store_identifier" />*/}
        {/*}*/}

        {/*<ContentRoute path="/intro" exact component={Intro}/>*/}
        <ContentRoute path="/s/:store_indentifier" component={CalendarPage}/>
        <ContentRoute path="/k/:order_key" component={DashboardPage} />
        <ContentRoute path="/o/:order_key/:form_type" component={WizardPage} />
        <ContentRoute path="/:pay/:result" component={PaymentPage} />
        {/*<ContentRoute path="/builder" component={BuilderPage} />*/}
        {/*<ContentRoute path="/order-sheet" component={OrderSheetPage}/>*/}
        {/*<Route path="/user-profile" component={UserProfilepage} />*/}
        {/*<Route path="/custom-wizard" component={WizardPage}/>*/}
        {/*<Redirect to="/error/error-v1" />*/}
      </Switch>
    </Suspense>
  );
}
